import LedByGPOContextProvider from './LedByGPOContextProvider'
import { LedByGPOList } from './LedByGPOList'

export const LedByGPO = ({ search }: { search: string }) => {
  return (
    <LedByGPOContextProvider>
      <LedByGPOList search={search} />
    </LedByGPOContextProvider>
  )
}
